import script from "./NavbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarView.vue?vue&type=script&setup=true&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=09c04366&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c04366"]])

export default __exports__